/**
 * Business data labels used to separate translation responsibility
 */
export class BusinessDataLabels {
  /**
   * @constructor
   */
  constructor(
    // NOSONAR
    public businessName: string,
    public businessAddress: string,
    public number: string,
    public country: string,
    public state: string,
    public postalCode: string,
    public phone: string,
    public typeOfBusiness: string,
    public businessContactEmail: string,
    public businessWebsite: string,
    public fileUpload: string[],
    public fileUploadAlt: string[]
  ) {}
}
